import axios from 'axios'

export default axios.create({
  headers: {
    Accept: 'application/ld+json',
    'Accept-Language': 'en'
  },
  auth: {
    username: 'cognito',
    password: 'cognito'
  }
})
